import IQOSCommunityImage from '../../images/IQOSCommunityImage.png';
function IQOSCommunity() {
    return (

        <div style={{ marginRight: '20px', marginTop: '20px' }}>
            <img src={IQOSCommunityImage} style={{ width: '100%', height: '' }} alt="" />
        </div>
    );
}
export default IQOSCommunity;